<template>
    <div class="flex flex-col drop-shadow-md z-50">
        <slot name="review-section" />

        <NavigationSection>
            <slot name="navigation-section" />
        </NavigationSection>

        <ContentSection
            :left-compensation-in-rem="props.leftCompensationInRem"
            :right-compensation-in-rem="props.rightCompensationInRem"
        >
            <slot name="content-section" />
        </ContentSection>

        <AllocationPreviewSection
            :left-compensation-in-rem="props.leftCompensationInRem"
            :right-compensation-in-rem="props.rightCompensationInRem"
        >
            <slot name="allocation-preview-section" />
        </AllocationPreviewSection>
    </div>
</template>

<script setup lang="ts">
import AllocationPreviewSection from './AllocationPreviewSection.vue';
import ContentSection from './ContentSection.vue';
import NavigationSection from './NavigationSection.vue';

type EditPopupProps = {
    leftCompensationInRem: number;
    rightCompensationInRem: number;
};

const props = defineProps<EditPopupProps>();
</script>
